import { filter, OperatorFunction } from "rxjs";

export function defined<T>():OperatorFunction<T,T>{
	return filter(v=>v!==undefined);
}
